import fetch from '../fetch';

const getInfoByTargetId = (keywords) => {
    return fetch.get('zgcp/enter/getInfoByTargetId/' + keywords.id)
    .then(response => {
        return response.payload;
    })
}

const getInfoByTargetIdAdd = (keywords) => {
    return fetch.post('zgcp/enter/getInfoByTargetIdAdd/' + keywords.id,{type: keywords.type})
    .then(response => {
        return response.payload;
    })
}

const getTabByResultId = (keywords) => {
    return fetch.get('zgcp/enter/getTabByResultId/' + keywords.id)
    .then(response => {
        return response.payload;
    })
}

const getInfoByResultId = (keywords) => {
    return fetch.post('zgcp/enter/getInfoByResultId/' + keywords.id,{type: keywords.type})
    .then(response => {
        return response.payload;
    })
}

const getViewByResultId = (keywords) => {
    return fetch.post('zgcp/enter/getViewByResultId/' + keywords.id,{type: keywords.type})
    .then(response => {
        return response.payload;
    })
}

const getAllInfoByResultId = (keywords) => {
    return fetch.post('zgcp/enter/getAllInfoByResultId/' + keywords.id,{type: keywords.type})
    .then(response => {
        return response.payload;
    })
}

const getAllViewByResultId = (keywords) => {
    return fetch.post('zgcp/enter/getAllViewByResultId/' + keywords.id,{type: keywords.type})
    .then(response => {
        return response.payload;
    })
}

const enterInsertInfo = (domain) => {
    return fetch.post('zgcp/enter/insert/targetResult' , domain)
    .then(response =>{
        return response
    })
}

const onlyInsertInfo = (domain) => {
    return fetch.post('zgcp/enter/update/targetResult' , domain)
    .then(response =>{
        return response
    })
}


/**
 * @method querySubitemByTargetId
 * @param {object} [keywords]
 * @return {promise}
 */
const getSubitemByTargetId = (keywords) => {
    return fetch.post('zgcp/enter/getSubitemByTargetId/'+ keywords.targetId, keywords)
    .then(response => {
        return response;
    });
}

const onSubmit = (id) => {
    
    return fetch.get('zgcp/enter/submit/' + id)
    .then(response => {
        return response
    });
}

const enterInsertResult = (data) => {
    return fetch.post('zgcp/enter/insert/subitemResult', data);
}

const deleteFile = (dataList) => {
    const ids = dataList.map(d => d.id);
    return fetch.post('zgcp/enter/file/delete', ids);
}

const removeInfoFile = (data) => {
    return fetch.post(`zgcp/enter/infoFile/delete`, data)
}

export default{
    getSubitemByTargetId,
    getInfoByTargetId,
    getInfoByTargetIdAdd,
    getTabByResultId,
    enterInsertInfo,
    onlyInsertInfo,
    getViewByResultId,
    onSubmit,
    upload: `${fetch.base}zgcp/enter/file`,
    deleteFile,
    removeInfoFile,
    enterInsertResult,
    getInfoByResultId,
    getAllInfoByResultId,
    getAllViewByResultId
}